import Quill from 'quill';
import Delta from 'quill-delta';
var PlaceholderHelper = /** @class */ (function () {
    function PlaceholderHelper() {
        this.placeholders = [];
        this.container = null;
        this.placeholderMarkup = new Map();
        this.container = (new DOMParser()).parseFromString('<div></div>', 'text/html').body;
        this.quill = new Quill(this.container);
    }
    PlaceholderHelper.prototype.setPlaceholders = function (placeholders, t) {
        var _this = this;
        this.placeholderMarkup.clear();
        this.placeholders = placeholders;
        this.placeholders.forEach(function (placeholder) {
            if (_this.placeholderMarkup.has(placeholder.type)) {
                return;
            }
            _this.placeholderMarkup.set(placeholder.type, _this.getPlaceholderHTML(placeholder, t));
        });
    };
    PlaceholderHelper.prototype.replaceElementsWithTags = function (html, stripHtml) {
        if (stripHtml === void 0) { stripHtml = false; }
        var parser = new DOMParser();
        var dom = parser.parseFromString(html, 'text/html');
        var elements = dom.querySelectorAll('.ql-template-placeholder');
        if (!elements.length) {
            if (stripHtml && html) {
                html = html.replace(/<[^>]*>?/gm, '');
            }
            return html;
        }
        Array.from(elements).forEach(function (element) {
            var type = element.dataset.placeholderType;
            var tag = dom.createTextNode("{" + type + "}");
            element.parentNode.insertBefore(tag, element);
            element.parentNode.removeChild(element);
        });
        if (stripHtml) {
            dom.body.innerHTML = dom.body.innerHTML.replace(/<[^>]*>?/gm, '');
        }
        return dom.body.innerHTML.trim();
    };
    PlaceholderHelper.prototype.replaceTagsWithElements = function (text, wrapInParagraph) {
        if (wrapInParagraph === void 0) { wrapInParagraph = false; }
        if (!text) {
            return;
        }
        var tempText = text.substr(0);
        this.placeholderMarkup.forEach(function (value, key) {
            tempText = tempText.replace(new RegExp("{" + key + "}", 'g'), value);
        });
        if (wrapInParagraph) {
            tempText = "<p>" + tempText + "</p>";
        }
        return tempText;
    };
    PlaceholderHelper.prototype.getPlaceholderHTML = function (placeholder, t) {
        this.quill.setText('');
        this.quill.insertEmbed(0, 'TemplatePlaceholderEmbed', { type: placeholder.type, text: t(placeholder.label) });
        return this.container.querySelector('.ql-template-placeholder').parentNode.innerHTML;
    };
    PlaceholderHelper.prototype.pasteNotAllowedDelta = function (node) {
        return new Delta().insert({
            TemplatePlaceholderNotAllowedEmbed: {
                text: node.querySelector('span').innerHTML,
                type: node.getAttribute('data-placeholder-type'),
            },
        });
    };
    PlaceholderHelper.prototype.pasteAllowedDelta = function (node) {
        return new Delta().insert({
            TemplatePlaceholderEmbed: {
                text: node.querySelector('span').innerHTML,
                type: node.getAttribute('data-placeholder-type'),
            },
        });
    };
    PlaceholderHelper.prototype.removeNotAllowedPlaceholders = function (delta) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Delta(delta.filter(function (op) { return (!(op.insert instanceof Object && op.insert.TemplatePlaceholderNotAllowedEmbed)); }));
    };
    PlaceholderHelper.convertPlaceholdersToValues = function (template, values) {
        if (values === void 0) { values = new Map(); }
        values.forEach(function (value, placeholderKey) { return template = template.replace(new RegExp("{" + placeholderKey + "}"), value); });
        return template.replace(/\s?{[^{}]+}/g, '').trim();
    };
    return PlaceholderHelper;
}());
export { PlaceholderHelper };
